import { render } from "./M423_Splashscreen.vue?vue&type=template&id=596e5cec&scoped=true"
import script from "./M423_Splashscreen.vue?vue&type=script&lang=js"
export * from "./M423_Splashscreen.vue?vue&type=script&lang=js"

import "./M423_Splashscreen.vue?vue&type=style&index=0&id=596e5cec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596e5cec"]])

export default __exports__